module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.members,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var props = ref.props;

        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar ml-2",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [_c('img', {
          attrs: {
            "src": props.item.avatar,
            "alt": props.item.firstname + ' ' + props.item.lastname
          }
        })]), _vm._v("\n          " + _vm._s(props.item.firstname + ' ' + props.item.lastname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companylegalname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), (_vm.user.uid === _vm.group.adminId) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-tooltip', {
          attrs: {
            "right": ""
          }
        }, [_c('v-btn', {
          staticClass: "reduce-fab",
          attrs: {
            "slot": "activator",
            "flat": "",
            "fab": ""
          },
          on: {
            "click": function($event) {
              return _vm.remove(props.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          staticClass: "red--text"
        }, [_vm._v("mdi-close-circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove " + _vm._s(props.item.firstname + ' ' + props.item.lastname))])], 1)], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9938d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/members.vue
// module id = 1680
// module chunks = 17